export function ruPlural(n, one, few, many) {
  const abs = Math.abs(Number(n) || 0) % 100;
  const n1 = abs % 10;
  if (abs > 10 && abs < 20) return many;
  if (n1 === 1) return one;
  if (n1 >= 2 && n1 <= 4) return few;
  return many;
}

export function likesCountLabel(n) {
  const count = Number(n) || 0;
  return `${count} ${ruPlural(count, "реакция", "реакции", "реакций")}`;
}

export function commentsCountLabel(n) {
  const count = Number(n) || 0;
  return `${count} ${ruPlural(count, "комментарий", "комментария", "комментариев")}`;
}

export function viewsCountLabel(n) {
  const count = Number(n) || 0;
  return `${count} ${ruPlural(count, "просмотр", "просмотра", "просмотров")}`;
}

export function membersCountLabel(n) {
  const count = Number(n) || 0;
  return `${count} ${ruPlural(count, "участник", "участника", "участников")}`;
}
